<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>

export default {
  name: 'app'
}
</script>

<style lang="scss">
@import '~@/assets/style/public-class.scss';
@import '~@/assets/style/responsive.scss';
@import '~@/assets/style/mobile.scss';
@import '~@/assets/style/element-mobile.scss';
</style>
